import Icon from 'snippets/icon/icon'

function CustomModalDialog({ header, content, useRichtext = false, footer, id, type = 'modal', classClose = 'w-8 h-8 p-2', classModal = '', classMain = '', classContent = '', classHeader = '', scrollTarget = '.modal-dialog-inner' }) {
  return (
    <modal-dialog data-target={id} data-type={type} data-scroll-target={scrollTarget} className={classModal} onClick={(e) => e.stopPropagation()}>
      <div className={`modal-dialog-content js-content-modal-dialog relative ${classMain}`}>
        <div className={`relative ${classHeader}`}>
          {header}
          <button type="button" className={`js-close-modal-dialog absolute top-3 right-4 h-8 w-8 p-2 md:top-4 md:right-6 ${classClose}`} title="close modal" aria-label="close modal">
            <Icon name="icon-close-outline" className="w-4 h-4 text-grey-500" />
          </button>
        </div>
        {useRichtext ? (
          <div className={`modal-dialog-inner ${classContent}`} dangerouslySetInnerHTML={{ __html: content }}></div>
        ) : (
          <div className={`modal-dialog-inner ${classContent}`}>{content}</div>
        )}
        {footer}
      </div>
    </modal-dialog>
  )
}

export default CustomModalDialog
